module.exports = __webpack_public_path__ + "static/media/Banner_1160x130.bf462601.jpg";